module.exports = __webpack_public_path__ + "img/57.7d573aac.png";